// 権限コード一覧
export const e部所権限コード = {
  経営: "1001",
  ロジ: "1002",
  事務: "1003",
  安全: "1004",
  車輌: "1005",
  管理: "1006",
  人事: "1007",
  本営: "1008",
  大川: "2001",
  金彰: "8001",
  大TP: "9001",
} as const

export const 車輌マスタ登録権限コード = {
  安全: e部所権限コード.安全,
  車輌: e部所権限コード.車輌,
  本営: e部所権限コード.本営,
  大川: e部所権限コード.大川,
  金彰: e部所権限コード.金彰,
} as const

export const 権限コード = {
  車輌マスタ登録: 車輌マスタ登録権限コード,
} as const

const 権限コード一覧 = {
  ...車輌マスタ登録権限コード,
} as const

export type T権限コード名称 = keyof typeof 権限コード一覧
export type T権限コード = typeof 権限コード一覧[T権限コード名称]
